import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import {
  addAssignWorkerAction,
  addOperationStaffAction,
  addSkillAction,
  addStaffAbsenceAction,
  addTrackWorkerAction,
  createTaskCrewAction,
  deleteAssignWorkerAction,
  deleteOperationStaffAction,
  deleteSkillAction,
  deleteStaffAbsenceAction,
  getAllAssignedWorkerListAction,
  getAllOperationStaffAction,
  getAllOperationTasksAction,
  getAllSkillAction,
  getAllStaffAbsenceAction,
  getAllTaskCrewListAction,
  getSingleOperationStaffAction,
  getSingleStaffAbsenceAction,
  getTrackWorkerDetailsAction,
  resetTaskCrewStateAction,
  setAddAssignWorkerAction,
  setAddOperationStaffAction,
  setAddSkillAction,
  setAddStaffAbsenceAction,
  setAddTrackWorkerAction,
  setAllAssignedWorkerListAction,
  setAllOperationStaffAction,
  setAllOperationTasksAction,
  setAllSkillAction,
  setAllStaffAbsenceAction,
  setAllTaskCrewListAction,
  setCreateTaskCrewAction,
  setDeleteAssignWorkerAction,
  setDeleteOperationStaffAction,
  setDeleteSkillAction,
  setDeleteStaffAbsenceAction,
  setResetTaskCrewStateAction,
  setSingleOperationStaffAction,
  setSingleStaffAbsenceAction,
  setTrackWorkerDetailsAction,
} from "../reducers/assignWorkerSlice";
import store from "../store";
/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getAllSkillSaga(): any {
  yield put(setLoaderAction(true));
  try {
    const res = yield call<any>(callAPI, {}, "get", `client/skills`);
    if (res?.data) {
      yield put(setAllSkillAction(res?.data));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error) {

  }
  yield put(setLoaderAction(false));
}

function* addSkillSaga({ payload }: any): any {
  yield put(setLoaderAction(true));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload },
      "post",
      `client/skills`
    );
    if (apiResponse?.success) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddSkillAction(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddSkillAction(false));
  }
  yield put(setLoaderAction(false));
}

function* deleteSkillSaga({ payload }: any): any {
  yield put(setLoaderAction(true));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `client/skills/${payload}`
    );
    if (apiResponse?.success) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setDeleteSkillAction(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setDeleteSkillAction(false));
  }
  yield put(setLoaderAction(false));
}

function* getAllAssignedWorkerListSaga({ payload }: any): any {
  yield put(setLoaderAction(true));
  try {
    const res = yield call<any>(callAPI, {}, "get", `client/workers`);
    if (res?.data) {
      yield put(setAllAssignedWorkerListAction(res?.data));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error) {
  }
  yield put(setLoaderAction(false));
}

function* addAssignWorkerSaga({ payload }: any): any {
  yield put(setLoaderAction(true));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload },
      "post",
      `client/workers`
    );
    if (apiResponse?.success) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddAssignWorkerAction(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddAssignWorkerAction(false));
  }
  yield put(setLoaderAction(false));
}

function* deleteAssignWorkerSaga({ payload }: any): any {
  yield put(setLoaderAction(true));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `client/workers/${payload}`
    );
    if (apiResponse?.success) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setDeleteAssignWorkerAction(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response, [401]);
    // error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setDeleteAssignWorkerAction(false));
  }
  yield put(setLoaderAction(false));
}

// staff

function* getAllOperationStaffSaga({ payload }: any): any {
  const { page, limit, orderBy, orderIn, search, skill, is_deleted } =
    payload || {};
  yield put(setLoaderAction(true));
  try {
    let query = `client/workers?page=${page || 1}&limit=${limit || 10}`;

    if (skill) query += `&skill=${skill}`;
    if (
      typeof is_deleted !== "undefined" &&
      is_deleted !== null &&
      is_deleted !== ""
    )
      query += `&is_deleted=${
        is_deleted === "Active" ? false : is_deleted === "Deleted" ? true : ""
      }`;
    const res = yield call<any>(callAPI, {}, "get", query);
    if (res?.data) {
      yield put(setAllOperationStaffAction(res?.data));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error) {
  }
  yield put(setLoaderAction(false));
}

function* addOperationStaffSaga({ payload }: any): any {
  yield put(setLoaderAction(true));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload },
      "post",
      `client/workers`
    );
    if (apiResponse?.success) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddOperationStaffAction(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddOperationStaffAction(false));
  }
  yield put(setLoaderAction(false));
}

function* getSingleOperationStaffSaga({ payload }: any): any {
  yield put(setLoaderAction(true));
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `client/workers/${payload}`
    );
    if (res?.data) {
      yield put(setSingleOperationStaffAction(res?.data));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error) {
  }
  yield put(setLoaderAction(false));
}

function* deleteOperationStaffSaga({ payload }: any): any {
  yield put(setLoaderAction(true));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `client/workers/${payload}`
    );
    if (apiResponse?.success) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setDeleteOperationStaffAction(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setDeleteOperationStaffAction(false));
  }
  yield put(setLoaderAction(false));
}

function* getAllStaffAbsenceSaga({ payload }: any): any {
  yield put(setLoaderAction(true));
  const { worker_id, start_date, end_date, page, limit } = payload;
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `client/workers-absences?worker_id=${worker_id || ""}&start_date=${
        start_date || ""
      }&end_date=${end_date || ""}&page=${page}&limit=${limit}`
    );
    if (res?.data) {
      yield put(setAllStaffAbsenceAction(res?.data));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error) {
  }
  yield put(setLoaderAction(false));
}

function* addStaffAbsenceSaga({ payload }: any): any {
  yield put(setLoaderAction(true));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload },
      "post",
      `client/workers-absences`
    );
    if (apiResponse?.success) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddStaffAbsenceAction(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddStaffAbsenceAction(false));
  }
  yield put(setLoaderAction(false));
}

function* getSingleStaffAbsenceSaga({ payload }: any): any {
  yield put(setLoaderAction(true));
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `client/workers-absences/${payload}`
    );
    if (res?.data) {
      yield put(setSingleStaffAbsenceAction(res?.data));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error) {
  }
  yield put(setLoaderAction(false));
}

function* deleteStaffAbsenceSaga({ payload }: any): any {
  yield put(setLoaderAction(true));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `client/workers-absences/${payload}`
    );
    if (apiResponse?.success) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setDeleteStaffAbsenceAction(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setDeleteStaffAbsenceAction(false));
  }
  yield put(setLoaderAction(false));
}

// operation tasks

function* getAllOperationTasksSaga({ payload }: any): any {
  const { page, limit, orderBy, orderIn, search, status, date } = payload || {};
  yield put(setLoaderAction(true));
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `leads/tasks/${date || ""}?page=${page || 1}&limit=${limit || 10}`
    );
    if (res?.data) {
      yield put(setAllOperationTasksAction(res?.data));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* createTaskCrewSaga({ payload }: any): any {
  yield put(setLoaderAction(true));
  // get date from first crew (assuming all crews share the same date)
  const date = payload?.crews?.[0]?.date;
  // check if any crew has an id
  const hasId = payload?.crews?.some((crew: any) => crew.id);
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload },
      hasId ? "put" : "post", // ✅ method is string, not object
      `leads/crews/${date}`
    );
    if (apiResponse?.success) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setCreateTaskCrewAction(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setCreateTaskCrewAction(false));
  }
  yield put(setLoaderAction(false));
}

function* getAllTaskCrewListSaga({ payload }: any): any {
  yield put(setLoaderAction(true));
  try {
    const res = yield call<any>(callAPI, {}, "get", `leads/crews/${payload}`);
    if (res?.data) {
      const userProfile: any = store.getState()?.user?.userProfile;
      const timezone: string = userProfile?.timezone || "UTC";
      yield put(setAllTaskCrewListAction({ ...res?.data, timezone }));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* resetTaskCrewStateSaga({ payload }: any): any {
  yield put(setLoaderAction(true));
  const { date } = payload || {};
  try {
    const res = yield call<any>(
      callAPI,
      { payload },
      "put",
      `leads/crews/${date}`
    );
    if (res?.success) {
      yield put(setResetTaskCrewStateAction(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setResetTaskCrewStateAction(false));
  }
  yield put(setLoaderAction(false));
}

function* getTrackWorkerDetailsSaga({ payload }: any): any {
  // yield put(setLoaderAction(true));
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `leads/track-worker-assignments/${payload}`
    );
    if (res?.data) {
      yield put(setTrackWorkerDetailsAction(res?.data));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* addTrackWorkerSaga({ payload }: any): any {
  yield put(setLoaderAction(true));
  const { date, ...rest } = payload || {};
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: rest },
      "post",
      `leads/track-worker-assignments/${date}`
    );
    if (apiResponse?.success) {
      // Success path: notify the component that the call succeeded
      yield put(setAddTrackWorkerAction(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    } else {
      // IMPORTANT: handle "success: false" responses that do NOT throw an error.
      // Without this branch, addTrackWorkerResponse never updates for this
      // kind of failure, and the component's "pending" flag stays stuck forever.
      yield put(setAddTrackWorkerAction(false));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    // Failure path: always notify the component so pending state can reset
    yield put(setAddTrackWorkerAction(false));
  }
  yield put(setLoaderAction(false));
}

export function* watchAssignWorker() {
  yield takeLatest<any>(getAllSkillAction, getAllSkillSaga);
  yield takeLatest<any>(addSkillAction, addSkillSaga);
  yield takeLatest<any>(deleteSkillAction, deleteSkillSaga);
  yield takeLatest<any>(
    getAllAssignedWorkerListAction,
    getAllAssignedWorkerListSaga
  );
  yield takeLatest<any>(addAssignWorkerAction, addAssignWorkerSaga);
  yield takeLatest<any>(deleteAssignWorkerAction, deleteAssignWorkerSaga);
  yield takeLatest<any>(getAllOperationStaffAction, getAllOperationStaffSaga);
  yield takeLatest<any>(addOperationStaffAction, addOperationStaffSaga);
  yield takeLatest<any>(deleteOperationStaffAction, deleteOperationStaffSaga);
  yield takeLatest<any>(
    getSingleOperationStaffAction,
    getSingleOperationStaffSaga
  );
  yield takeLatest<any>(getAllStaffAbsenceAction, getAllStaffAbsenceSaga);
  yield takeLatest<any>(addStaffAbsenceAction, addStaffAbsenceSaga);
  yield takeLatest<any>(getSingleStaffAbsenceAction, getSingleStaffAbsenceSaga);
  yield takeLatest<any>(deleteStaffAbsenceAction, deleteStaffAbsenceSaga);
  yield takeLatest<any>(getAllOperationTasksAction, getAllOperationTasksSaga);
  yield takeLatest<any>(createTaskCrewAction, createTaskCrewSaga);
  yield takeLatest<any>(getAllTaskCrewListAction, getAllTaskCrewListSaga);
  yield takeLatest<any>(resetTaskCrewStateAction, resetTaskCrewStateSaga);
  yield takeLatest<any>(getTrackWorkerDetailsAction, getTrackWorkerDetailsSaga);
  yield takeLatest<any>(addTrackWorkerAction, addTrackWorkerSaga);
}
